export default function EventInfoWebsite({
  website,
}) {
  return (
    <a href={website} className="flex items-center justify-center space-x-2 bg-green-600 hover:bg-green-500 transition ease-in-out duration-300 rounded pl-2 pr-4 py-2" target="_blank" rel="noopener noreferrer">
      <div className="font-semibold text-lg">
        Más información
      </div>
    </a>
  );
}
